// AUTO-GENERATED by build-tokens.mjs — do not edit. The per-theme --fawkes-* token map
// (Style Dictionary, single source of truth). Consumed by the jve-3-4 visual-regression harness.
export const themeTokens = {
  "docasoft-green": {
    "--fawkes-text-xs": "12px",
    "--fawkes-text-sm": "14px",
    "--fawkes-text-md": "16px",
    "--fawkes-text-lg": "18px",
    "--fawkes-text-xl": "22px",
    "--fawkes-text-2xl": "28px",
    "--fawkes-text-3xl": "34px",
    "--fawkes-leading-xs": "16px",
    "--fawkes-leading-sm": "20px",
    "--fawkes-leading-md": "24px",
    "--fawkes-leading-lg": "28px",
    "--fawkes-leading-xl": "32px",
    "--fawkes-leading-2xl": "38px",
    "--fawkes-leading-3xl": "44px",
    "--fawkes-space-1": "4px",
    "--fawkes-space-2": "8px",
    "--fawkes-space-3": "12px",
    "--fawkes-space-4": "16px",
    "--fawkes-space-5": "20px",
    "--fawkes-space-6": "24px",
    "--fawkes-space-8": "32px",
    "--fawkes-space-10": "40px",
    "--fawkes-space-12": "48px",
    "--fawkes-radius-sm": "6px",
    "--fawkes-radius-md": "10px",
    "--fawkes-radius-lg": "14px",
    "--fawkes-radius-pill": "999px",
    "--fawkes-font-mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
    "--fawkes-font-body": "'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif",
    "--fawkes-font-display": "'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif",
    "--fawkes-font-display-weight": "700",
    "--fawkes-font-display-tracking": "-0.01em",
    "--fawkes-color-primary": "#5a7d6c",
    "--fawkes-color-primary-hover": "#4e6f5f",
    "--fawkes-color-primary-soft": "#e7f0ec",
    "--fawkes-color-primary-fg": "#ffffff",
    "--fawkes-color-accent": "#6b8b7b",
    "--fawkes-color-bg": "#ffffff",
    "--fawkes-color-surface": "#ffffff",
    "--fawkes-color-surface-hover": "#e8edf1",
    "--fawkes-color-surface-muted": "#f1f4f6",
    "--fawkes-color-text": "#25313b",
    "--fawkes-color-text-muted": "#586775",
    "--fawkes-color-border": "#dfe5ea",
    "--fawkes-color-border-strong": "#b9c4cd",
    "--fawkes-color-success": "#3d8a5e",
    "--fawkes-color-success-soft": "#e3f1e9",
    "--fawkes-color-warning": "#d49017",
    "--fawkes-color-warning-soft": "#fbedd0",
    "--fawkes-color-caution": "#c99a1e",
    "--fawkes-color-caution-soft": "#f3e7bf",
    "--fawkes-color-danger": "#b53a2c",
    "--fawkes-color-danger-hover": "#992f24",
    "--fawkes-color-danger-soft": "#f7dcd6",
    "--fawkes-color-info": "#3478b8",
    "--fawkes-color-info-soft": "#dde9f5",
    "--fawkes-color-foster": "#8b5cf6",
    "--fawkes-color-foster-soft": "#f8f5fe",
    "--fawkes-shadow-1": "0 1px 2px rgba(37, 49, 59, 0.08)",
    "--fawkes-shadow-2": "0 2px 8px rgba(37, 49, 59, 0.08)",
    "--fawkes-shadow-3": "0 4px 12px rgba(37, 49, 59, 0.12)",
    "--fawkes-sidebar-bg-top": "#f4f6f8",
    "--fawkes-sidebar-bg-bottom": "#eef1f4",
    "--fawkes-sidebar-border": "rgba(37, 49, 59, 0.12)",
    "--fawkes-sidebar-title": "#25313b",
    "--fawkes-sidebar-text": "#2f3b45",
    "--fawkes-sidebar-muted": "#586775",
    "--fawkes-sidebar-active-bg": "#e7f0ec"
  },
  "warm": {
    "--fawkes-text-xs": "12px",
    "--fawkes-text-sm": "14px",
    "--fawkes-text-md": "16px",
    "--fawkes-text-lg": "18px",
    "--fawkes-text-xl": "22px",
    "--fawkes-text-2xl": "28px",
    "--fawkes-text-3xl": "34px",
    "--fawkes-leading-xs": "16px",
    "--fawkes-leading-sm": "20px",
    "--fawkes-leading-md": "24px",
    "--fawkes-leading-lg": "28px",
    "--fawkes-leading-xl": "32px",
    "--fawkes-leading-2xl": "38px",
    "--fawkes-leading-3xl": "44px",
    "--fawkes-space-1": "4px",
    "--fawkes-space-2": "8px",
    "--fawkes-space-3": "12px",
    "--fawkes-space-4": "16px",
    "--fawkes-space-5": "20px",
    "--fawkes-space-6": "24px",
    "--fawkes-space-8": "32px",
    "--fawkes-space-10": "40px",
    "--fawkes-space-12": "48px",
    "--fawkes-radius-sm": "6px",
    "--fawkes-radius-md": "10px",
    "--fawkes-radius-lg": "14px",
    "--fawkes-radius-pill": "999px",
    "--fawkes-font-mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
    "--fawkes-font-body": "'Inter', system-ui, sans-serif",
    "--fawkes-font-display": "'Fraunces', 'Source Serif Pro', Georgia, serif",
    "--fawkes-font-display-weight": "600",
    "--fawkes-font-display-tracking": "-0.015em",
    "--fawkes-color-primary": "#a06a3f",
    "--fawkes-color-primary-hover": "#8a5832",
    "--fawkes-color-primary-soft": "#f5e9da",
    "--fawkes-color-primary-fg": "#ffffff",
    "--fawkes-color-accent": "#c89a4f",
    "--fawkes-color-bg": "#f4e8d0",
    "--fawkes-color-surface": "#fdf6e3",
    "--fawkes-color-surface-hover": "#f3e8ce",
    "--fawkes-color-surface-muted": "#ebdfc4",
    "--fawkes-color-text": "#3a2e1e",
    "--fawkes-color-text-muted": "#6a5a3e",
    "--fawkes-color-border": "#e4d9be",
    "--fawkes-color-border-strong": "#c2af86",
    "--fawkes-color-success": "#6f8c4f",
    "--fawkes-color-success-soft": "#ecf0d8",
    "--fawkes-color-warning": "#c47a1a",
    "--fawkes-color-warning-soft": "#f8e3c4",
    "--fawkes-color-caution": "#b8901f",
    "--fawkes-color-caution-soft": "#efe0b8",
    "--fawkes-color-danger": "#a73a26",
    "--fawkes-color-danger-hover": "#8c2f1e",
    "--fawkes-color-danger-soft": "#f0d3c8",
    "--fawkes-color-info": "#7e8aa0",
    "--fawkes-color-info-soft": "#e3e6ec",
    "--fawkes-color-foster": "#7d5ba6",
    "--fawkes-color-foster-soft": "#f3ecf2",
    "--fawkes-shadow-1": "0 1px 2px rgba(58, 46, 30, 0.10)",
    "--fawkes-shadow-2": "0 2px 8px rgba(58, 46, 30, 0.10)",
    "--fawkes-shadow-3": "0 4px 12px rgba(58, 46, 30, 0.14)",
    "--fawkes-sidebar-bg-top": "#f7ecd5",
    "--fawkes-sidebar-bg-bottom": "#f0e3c5",
    "--fawkes-sidebar-border": "rgba(58, 46, 30, 0.15)",
    "--fawkes-sidebar-title": "#3a2e1e",
    "--fawkes-sidebar-text": "#4a3e2e",
    "--fawkes-sidebar-muted": "#6a5a3e",
    "--fawkes-sidebar-active-bg": "#f5e9da"
  },
  "dark": {
    "--fawkes-text-xs": "12px",
    "--fawkes-text-sm": "14px",
    "--fawkes-text-md": "16px",
    "--fawkes-text-lg": "18px",
    "--fawkes-text-xl": "22px",
    "--fawkes-text-2xl": "28px",
    "--fawkes-text-3xl": "34px",
    "--fawkes-leading-xs": "16px",
    "--fawkes-leading-sm": "20px",
    "--fawkes-leading-md": "24px",
    "--fawkes-leading-lg": "28px",
    "--fawkes-leading-xl": "32px",
    "--fawkes-leading-2xl": "38px",
    "--fawkes-leading-3xl": "44px",
    "--fawkes-space-1": "4px",
    "--fawkes-space-2": "8px",
    "--fawkes-space-3": "12px",
    "--fawkes-space-4": "16px",
    "--fawkes-space-5": "20px",
    "--fawkes-space-6": "24px",
    "--fawkes-space-8": "32px",
    "--fawkes-space-10": "40px",
    "--fawkes-space-12": "48px",
    "--fawkes-radius-sm": "6px",
    "--fawkes-radius-md": "10px",
    "--fawkes-radius-lg": "14px",
    "--fawkes-radius-pill": "999px",
    "--fawkes-font-mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
    "--fawkes-font-body": "'IBM Plex Sans', system-ui, sans-serif",
    "--fawkes-font-display": "'IBM Plex Sans', system-ui, sans-serif",
    "--fawkes-font-display-weight": "600",
    "--fawkes-font-display-tracking": "-0.005em",
    "--fawkes-color-primary": "#7faea0",
    "--fawkes-color-primary-hover": "#6b9a8e",
    "--fawkes-color-primary-soft": "#243a36",
    "--fawkes-color-primary-fg": "#0d1416",
    "--fawkes-color-accent": "#a8d2c2",
    "--fawkes-color-bg": "#1c2226",
    "--fawkes-color-surface": "#262d33",
    "--fawkes-color-surface-hover": "#313941",
    "--fawkes-color-surface-muted": "#1f262b",
    "--fawkes-color-text": "#e6ebef",
    "--fawkes-color-text-muted": "#9aa6b0",
    "--fawkes-color-border": "#384149",
    "--fawkes-color-border-strong": "#5b6770",
    "--fawkes-color-success": "#7fbf95",
    "--fawkes-color-success-soft": "#213d2c",
    "--fawkes-color-warning": "#e8b35c",
    "--fawkes-color-warning-soft": "#3d2f17",
    "--fawkes-color-caution": "#e6cf6a",
    "--fawkes-color-caution-soft": "#3a3319",
    "--fawkes-color-danger": "#e87a6e",
    "--fawkes-color-danger-hover": "#d4655a",
    "--fawkes-color-danger-soft": "#3a1f1c",
    "--fawkes-color-info": "#80b3da",
    "--fawkes-color-info-soft": "#1c2a36",
    "--fawkes-color-foster": "#a78bfa",
    "--fawkes-color-foster-soft": "#2e2a3d",
    "--fawkes-shadow-1": "0 1px 2px rgba(0, 0, 0, 0.40)",
    "--fawkes-shadow-2": "0 2px 8px rgba(0, 0, 0, 0.45)",
    "--fawkes-shadow-3": "0 4px 14px rgba(0, 0, 0, 0.55)",
    "--fawkes-sidebar-bg-top": "#262d33",
    "--fawkes-sidebar-bg-bottom": "#1c2226",
    "--fawkes-sidebar-border": "#384149",
    "--fawkes-sidebar-title": "#e6ebef",
    "--fawkes-sidebar-text": "#e6ebef",
    "--fawkes-sidebar-muted": "#9aa6b0",
    "--fawkes-sidebar-active-bg": "#243a36"
  },
  "high-contrast": {
    "--fawkes-text-xs": "12px",
    "--fawkes-text-sm": "14px",
    "--fawkes-text-md": "16px",
    "--fawkes-text-lg": "18px",
    "--fawkes-text-xl": "22px",
    "--fawkes-text-2xl": "28px",
    "--fawkes-text-3xl": "34px",
    "--fawkes-leading-xs": "16px",
    "--fawkes-leading-sm": "20px",
    "--fawkes-leading-md": "24px",
    "--fawkes-leading-lg": "28px",
    "--fawkes-leading-xl": "32px",
    "--fawkes-leading-2xl": "38px",
    "--fawkes-leading-3xl": "44px",
    "--fawkes-space-1": "4px",
    "--fawkes-space-2": "8px",
    "--fawkes-space-3": "12px",
    "--fawkes-space-4": "16px",
    "--fawkes-space-5": "20px",
    "--fawkes-space-6": "24px",
    "--fawkes-space-8": "32px",
    "--fawkes-space-10": "40px",
    "--fawkes-space-12": "48px",
    "--fawkes-radius-sm": "6px",
    "--fawkes-radius-md": "10px",
    "--fawkes-radius-lg": "14px",
    "--fawkes-radius-pill": "999px",
    "--fawkes-font-mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
    "--fawkes-font-body": "'Atkinson Hyperlegible', system-ui, sans-serif",
    "--fawkes-font-display": "'Atkinson Hyperlegible', system-ui, sans-serif",
    "--fawkes-font-display-weight": "700",
    "--fawkes-font-display-tracking": "0",
    "--fawkes-color-primary": "#003f8a",
    "--fawkes-color-primary-hover": "#002b66",
    "--fawkes-color-primary-soft": "#cfe0ff",
    "--fawkes-color-primary-fg": "#ffffff",
    "--fawkes-color-accent": "#ff7a00",
    "--fawkes-color-bg": "#ffffff",
    "--fawkes-color-surface": "#ffffff",
    "--fawkes-color-surface-hover": "#e0e0e0",
    "--fawkes-color-surface-muted": "#f5f5f5",
    "--fawkes-color-text": "#000000",
    "--fawkes-color-text-muted": "#1f1f1f",
    "--fawkes-color-border": "#000000",
    "--fawkes-color-border-strong": "#000000",
    "--fawkes-color-success": "#006400",
    "--fawkes-color-success-soft": "#d4f0d4",
    "--fawkes-color-warning": "#cc6600",
    "--fawkes-color-warning-soft": "#ffe6cc",
    "--fawkes-color-caution": "#8a6d00",
    "--fawkes-color-caution-soft": "#fff4c2",
    "--fawkes-color-danger": "#a30000",
    "--fawkes-color-danger-hover": "#7a0000",
    "--fawkes-color-danger-soft": "#ffd1d1",
    "--fawkes-color-info": "#003f8a",
    "--fawkes-color-info-soft": "#cfe0ff",
    "--fawkes-color-foster": "#5b21b6",
    "--fawkes-color-foster-soft": "#e6d9ff",
    "--fawkes-shadow-1": "0 1px 2px rgba(0, 0, 0, 0.18)",
    "--fawkes-shadow-2": "0 2px 8px rgba(0, 0, 0, 0.20)",
    "--fawkes-shadow-3": "0 4px 12px rgba(0, 0, 0, 0.28)",
    "--fawkes-sidebar-bg-top": "#ffffff",
    "--fawkes-sidebar-bg-bottom": "#ffffff",
    "--fawkes-sidebar-border": "#000000",
    "--fawkes-sidebar-title": "#000000",
    "--fawkes-sidebar-text": "#000000",
    "--fawkes-sidebar-muted": "#1f1f1f",
    "--fawkes-sidebar-active-bg": "#cfe0ff"
  }
} as const;

export type ThemeName = keyof typeof themeTokens;
export const themeNames = Object.keys(themeTokens) as ThemeName[];
export const DEFAULT_THEME: ThemeName = "docasoft-green";
